module.exports = __webpack_public_path__ + "img/GI.dd1fdf7f.svg";